import styles from "@styles/pages/flow/FlowTableItem.module.scss";
import classNames from "classnames/bind";
import dayjs from "dayjs";
import { useState } from "react";
const css = classNames.bind(styles);

export const FlowTableItem = ({ flow, onClick }) => {
  const getCampaignStatus = (value) => {
    const status = {
      ACTIVE: "success",
      FINISHED: "success",
      UNDER_ANALYSIS: "neutral",
      DRAFT: "neutral",
      EXPIRED_DRAFT: "danger",
      ARCHIVED: "neutral",
      SCHEDULED: "neutral",
      PROCESSING: "neutral",
      PAUSED: "paused",
      PUBLISHED: "success",
    };

    return status[value] || "exclamation";
  };

  const getCampaignStatusName = (value) => {
    const status = {
      ACTIVE: "Ativa",
      FINISHED: "Encerrada",
      UNDER_ANALYSIS: "Em análise",
      DRAFT: "Rascunho",
      EXPIRED_DRAFT: "Rascunho expirado",
      ARCHIVED: "Arquivado",
      SCHEDULED: "Enviando",
      PROCESSING: "Enviando",
      PAUSED: "Pausada",
      PUBLISHED: flow?.rank_bypass ? "Publicado com prioridade" : "Publicado",
    };

    return status[value] || "Erro";
  };

  const [collapsed, setCollapsed] = useState(false);

  return (
    <tr
      onClick={() => onClick && onClick(flow)}
      className={css({ flow: true, table: true })}
    >
      <td>
        <div className="d-flex align-center">
          <div className={styles.icon}>
            <i className="far fa-arrows-split-up-and-left" />
          </div>
          <p>{flow.name}</p>
        </div>
      </td>
      <td>
        <div className="d-flex">
          <div className={styles.status}>
            <p className={css({ [getCampaignStatus(flow.state)]: true })}>
              {getCampaignStatusName(flow.state)}
            </p>
          </div>
        </div>
      </td>
      {/* <td>
        <p>{3}</p>
      </td> */}
      <td>
        <p>
          {dayjs(flow.updated_at).format("DD/MM/YYYY")} <span>às</span>{" "}
          {dayjs(flow.updated_at).format("HH:mm")}
        </p>
      </td>
      <td
        onClick={(e) => {
          e.stopPropagation();
          setCollapsed(!collapsed);
        }}
      >
        <div className={styles.chevron}>
          <i className="fal fa-ellipsis-v" />

          <div
            className={css({
              actions: true,
              in: collapsed,
              out: !collapsed,
            })}
          >
            <ul className={styles.options}>
              <li onClick={() => {}}>Duplicar fluxo</li>
              <li onClick={() => {}}>Arquivar fluxo</li>
            </ul>
          </div>
        </div>
      </td>
    </tr>
  );
};
